import React from 'react';
import { MapPin } from 'lucide-react';
import { getPokemonImageUrl } from '../../utils/imageUtils';

const WildEncountersSection = ({ wildEncounters }) => {
  if (!wildEncounters || wildEncounters.length === 0) return null;

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <MapPin className="w-6 h-6 text-green-500" />
        <h2 className="text-2xl font-bold text-gray-800">Wild Encounters</h2>
      </div>
      
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4">
        {wildEncounters.map((encounter, index) => {
          const imageUrl = encounter.pokemon_id 
            ? getPokemonImageUrl(encounter.pokemon_id)
            : '/images/pokemon/0000.webp';
          
          return (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-3 text-center hover:shadow-md transition-shadow"
            >
              <img
                src={imageUrl}
                alt={encounter.pokemon_name || 'Pokemon'}
                className="w-16 h-16 mx-auto object-contain mb-2"
                onError={(e) => {
                  e.target.src = '/images/pokemon/0000.webp';
                }}
              />
              <p className="font-medium text-gray-800 text-xs">
                {encounter.pokemon_name || 'Unknown'}
              </p>
              {encounter.is_shiny_available && (
                <span className="inline-block mt-1 text-[10px] text-yellow-600 font-bold">
                  ✨
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WildEncountersSection;
